export default __webpack_public_path__ + "0bc08c50886a7d4951b26d394914c9b5.jpg";